import useJwt from '@core/auth/jwt/useJwt'
import { axiosIns } from '@/libs/api'

const { jwt } = useJwt(axiosIns, {})
export default jwt
